import React from "react";
import { DialogBox } from "../../shared/components/dialog";
import { Avatar, Chip, DialogContent, Stack, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useArcAuth } from "@arcauth/react-sdk";
import { getUserInfo } from "../../redux/features/user.slice";
import { signoutFromEverywhere } from "../../redux/features/auth.slice";
import { removeCookie, setCookie } from "../token";
import { RootStateType } from "../../redux/features/rootSlice";
import {  useNavigate } from "react-router-dom";
import { clientsType, webSocketMessage } from "../../config/app";
import useWebSocket from "../../hooks/useWebSocket";
export interface DialogProps {
  open: boolean;
  onClose: () => void;

}
const Signout = (props: DialogProps) => {
  const dispatch = useDispatch();
  const { logout } = useArcAuth();
  const navigate = useNavigate();
  const { open, onClose } = props;
  const { updateUserAndNotifyParent } = useWebSocket();
  const {id} = useSelector(
    (state: RootStateType) => state.userStateReducer.user
  );
  const storedClientId = useSelector((state: RootStateType) => state.configStateReducer.clientId);
  const signout_Loading = useSelector(
    (state: RootStateType) => state.authStateReducer.setSignoutLoading
  );
  const clientType = useSelector((state: RootStateType) => state.deviceConfigReducer.clientType);
  // console.log("clientType", clientType)
  const dialogClose = () => {
    onClose();
  };

  const handleListItemClick = async () => {
    const dispatchObj = {
      params : { userid: id },
      callBackSuccess: () => {
        updateUserAndNotifyParent(webSocketMessage.signoutResponse); 
        removeCookie(`lastState=`, 0, storedClientId);
        removeCookie(`user=`, 0, storedClientId);
        setCookie(`app.at_exp=`, 0, storedClientId);
        setCookie(`app.at=`, 0, storedClientId);
        setCookie(`app.rt=`, 0, storedClientId);
        localStorage.clear();
        logout();
        onClose();
        /**
          * NOTE: uncommenting this if signout from everywhere needed
          * for device.
        */ 
        // if (clientType && clientType === clientsType.device) {
        //   console.log("under if")
        //   // navigate("/error");
        //   // Trigger the custom protocol
        //   window.location.href = 'arcauth.facilities:/oauthredirect';
        // }
        // else {
        //   console.log("under else")
        //   logout();
        // }
      },
    };
    dispatch(signoutFromEverywhere(dispatchObj));
  };
  return (
    <>
      <DialogBox
        onClose={dialogClose}
        title={"Sign out everywhere?"}
        buttonText={"Sign out"}
        buttonClick={handleListItemClick}
        isLoading={signout_Loading}
        open={open}
        style={{ maxWidth: 500, mx: "auto" }}
      >
        <DialogContent sx={{ py: 0 }}>
          <Stack direction={"row"} gap={1} alignItems={"center"}>
            <Typography>
              Are you sure? This will sign you out of all sessions and all devices.
            </Typography>
          </Stack>
        </DialogContent>
      </DialogBox>
    </>
  );
};

export default Signout;
